import React, { useEffect, useState,useRef, useCallback  } from 'react'
import { Breadcrumb, CardBasic, PaginationCustom, DateRangeP, SButton, TextInput, ModalForm, ConfirmModal } from '../../components'
import Select from 'react-select';
import {useLocation, useNavigate } from 'react-router-dom';
import { Ceklis, Man } from '../../assets';
import { API_BASE_URL } from '../../config';
import { useSelector } from 'react-redux';
import ShowAlert from '../../components/ShowAlert';



function Registration() {
    const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
    const [searchTerm, setSearchTerm] = useState('');
    const [dateRange, setDateRange] =  useState({
        startDate: new Date(),
        endDate: new Date(),
    });
    

    const [apiData, setApiData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [therapisOpt, setTherapisOpt] = useState([]);
    const [optRoom,setRoom] = useState([]);

    const [showNotif, setShowNotif] = useState(false);
    const [notifType, setNotifType] = useState('success');
    const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');

    const user = useSelector((state) => state.auth);
    const location = useLocation();
    const navigate = useNavigate();

    const arr = [
        {label: 'All',value: 'All'},
        {label: 'Receipt',value: 'Receipt'},
        {label: 'Refund',value: 'Refund'},
        {label: 'Being Handled',value: 'Being Handled'},
        {label: 'Cancel',value: 'Cancel'}
    ];

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleCreate = () => {
        navigate('create')
    };


    function formatDate(date, withTime = false) {
        const d = typeof date === 'string' ? new Date(date) : date;
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        if (withTime) {
            return `${yyyy}-${mm}-${dd} 23:59:59`;
        }else{
            return `${yyyy}-${mm}-${dd}`;
        }
    }

    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await fetch(
                `${API_BASE_URL}/auth/registration/all`, 
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );
            if (!res.ok) {
                const errorData = await res.json().catch(() => ({}));
                console.log(errorData.message || 'Gagal mengambil data registrasi!');
                return;
            }
            const data = await res.json();
            setApiData(data);
        } catch (error) {
            if (window.confirm('Gagal mengambil data. Coba lagi?')) {
                fetchData();
            }
        }
    }, []);

    const fetchTherapis = useCallback(async () => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await fetch(
                `${API_BASE_URL}/auth/employee_get_klinik/${user.user.klinik_id}`, 
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );
            if (!res.ok) {
                const errorData = await res.json().catch(() => ({}));
                console.log(errorData.message || 'Gagal mengambil data therapis!');
                return;
            }
            const therapists = await res.json();                   

            setTherapisOpt(
                Array.isArray(therapists.data)
                    ? therapists.data.map(item => ({
                        value: item.id || item.value,
                        label: item.full_name || item.label,
                    }))
                    : []
            );
        } catch (error) {
            console.error("Error fetching therapis:", error);
        }
    },[user.user.klinik_id]);

    const fetchRooms = useCallback(async () => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await fetch(
                `${API_BASE_URL}/auth/room_get_klinik/${user.user.klinik_id}`, 
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );
            if (!res.ok) {
                const errorData = await res.json().catch(() => ({}));
                console.log(errorData.message || 'Gagal mengambil data registrasi!');
                return;
            }
            const rooms = await res.json();
        
            setRoom(
                Array.isArray(rooms.data)
                    ? rooms.data.map(item => ({
                        value: item.id || item.value,
                        label: item.name_room || item.label,
                    }))
                    : []
            );
        } catch (error) {
            console.error("Error fetching room:", error);
        }
    },[user.user.klinik_id]);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([
            fetchData(),
            fetchTherapis(),
            fetchRooms()
        ]).finally(() => {
            setIsLoading(false);
        });
    },[fetchData, fetchTherapis, fetchRooms]);


    useEffect(() => {
            const filterByDateAndStatus = (data = []) => {
                const filteredData = data.filter((item) => {
                    const itemDate = formatDate(item.created_at); // Normalize item date
                    const startDate = formatDate(dateRange.startDate); // Normalize start date
                    const endDate = formatDate(dateRange.endDate,true); // Normalize end date
                    const dateMatch = itemDate >= startDate && itemDate <= endDate;// Filter by date
                    
                    const statusMatch = selectedStatus.value === 'All' || item.status === selectedStatus.value; // Filter by status
                    const searchMatch = searchTerm.trim() === "" || item.patient.toLowerCase().includes(searchTerm.toLowerCase()); // Filter by search term
                    return dateMatch && statusMatch && searchMatch;
                });

                // const sortedData = filteredData.sort((a, b) => {
                //     const dateA = new Date(normalizeDate(a.created_at));
                //     const dateB = new Date(normalizeDate(b.created_at));
                //     return dateA - dateB; // Ascending order
                // });

                return filteredData;
            };
            
            const filteredAndSortedData  = filterByDateAndStatus(apiData.data);
            setNewData(filteredAndSortedData);
    }, [apiData, dateRange,selectedStatus,searchTerm]);


    const CardTitle = () => {
        const Added = () => {
            return (
                <>
                    <i className="ki-outline ki-plus fs-2"></i>Registration
                </>
            )
        }

        return (
            <>
                <div className='card-title'>
                    <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                        <TextInput type={'text'} 
                        clas={'form-control form-control-solid w-250px ps-12'}
                        placeholder={'Search Patient'}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        />
                    </div>
                </div>
                <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
                    <DateRangeP
                        selectedDate={dateRange}
                        setSelectedDate={setDateRange}
                    />
                    <div className="w-150px">
                        <Select
                            className=""
                            options={arr}
                            placeholder="Status"
                            isSearchable={false}
                            value={selectedStatus}
                            onChange={handleStatusChange}
                        />
                    </div>
                
                    <div>
                        <SButton
                            className={"btn btn-light-primary"}
                            children={<Added/>}
                            action={handleCreate}
                        />
                    </div>
                </div>
            </>
        )
    }

    const ListBody = ({arr,fetchData, therapisOpt, optRoom}) => {
        const [activeIndex, setActiveIndex] = useState(null);
        const [filteredData, setFilteredData] = useState([]);
        const [showModal, setShowModal] = useState(false);
        const [currentData, setCurrentData] = useState([]);

        const [showCancelModal, setShowCancelModal] = useState(false);
        const [selectedUser, setSelectedUser] = useState(null);
        const [fields, setFields] = useState([]);

        const dropdownRef = useRef([]);


        //Toogle Button
        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        // Menutup dropdown jika klik di luar
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        const handlePagination = useCallback((data) => {
            setFilteredData((prevData) => {
                // Hanya setState jika data berbeda
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    return data;
                }
                return prevData;
            });
        }, []);

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        // const normalizeData = (data) => {
        //     // Jika data adalah array, gabungkan nilai value-nya menjadi string
        //     if (Array.isArray(data)) {
        //         return data.map(item => item.value).join(', ');
        //     }

        //     // Jika data adalah string, langsung kembalikan
        //     return data;
        // };

        const handleEditModal  = (item) => {
            const selectedDoctor = therapisOpt.find(opt => Number(opt.value) === Number(item.doctor)) || { value: item.doctor, label: `Unknown` };
            const selectedRoom = optRoom.find(opt => Number(opt.value) === Number(item.room_id)) || { value: item.room_id, label: `Unknown ` };
            
            setCurrentData({
                id: item.id,
                patient: item.full_name,
                date: item.created_at,
                name: item.full_name,
                no_appointment: item.no_appointment ?? null,
                no_medical_record: item.no_medical_record,
                no_regist: item.no_regist,
                doctor: selectedDoctor,
                room_id: selectedRoom
            });


            setFields(
                [
                    { type: 'hidden', name: 'id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'no_medical_record', label: 'medical_record',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'text', name: 'name', label: 'Name Patient',classLabel: 'form-label' ,placeholder: 'Enter name', value: '', className: '',disable: true,required: true},
                    { type: 'date', name: 'date', label: 'Date', classLabel: 'form-label',value: '', className: '',disable: false,required: true},
                    { type: 'select', name: 'doctor', label: 'Doctor',classLabel: 'form-label' ,options: therapisOpt, placeholder: 'Select Doctor', value: selectedDoctor, className: '',disable: false,required: true  },
                    { type: 'select', name: 'room_id', label: 'Room',classLabel: 'form-label' ,options: optRoom, placeholder: 'Select Room', value: selectedRoom, className: '',disable: false,required: true  },
                ]
            )
            
            setShowModal(true); 
        }

        const handleCloseModal = () => {
            setShowModal(false);
        };

         // Fungsi untuk menangani penutupan modal notifikasi
        const handleCloseConfirm = () => {
            setShowNotif(false);

            // Navigasi setelah notifikasi ditutup
            const basePath = location.pathname.split('/')[1];
            navigate(`/${basePath}`);
        };

        const formatDateYMD = (date) => {
            if (!date) return '';
            const d = new Date(date);
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };

        const handleSaveModal = async (updatedData,data) => {
                const updRegistration = {
                    id: updatedData?.id,
                    created_at: formatDateYMD(updatedData?.date),
                    name: updatedData?.name,
                    no_medical_record: updatedData?.no_medical_record,
                    doctor: Array.isArray(updatedData?.doctor) 
                        ? updatedData?.doctor.map(item => item.value || item) // Simpan sebagai array of IDs jika multiselect
                        : updatedData?.doctor?.value || updatedData?.doctor || null, // Simpan sebagai ID saja jika single select
                    room_id: Array.isArray(updatedData?.room_id) 
                        ? updatedData?.room_id.map(item => item.value || item) 
                        : updatedData?.room_id?.value || updatedData?.room_id || null
                };
                setLoadingSave(true);

                try {
                    const token = localStorage.getItem('access_token');
                    const res = await fetch(`${API_BASE_URL}/auth/registration/${updatedData.id}`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(updRegistration)
                    });

                    if (!res.ok) {
                        const errorData = await res.json().catch(() => ({}));
                        setNotifType('danger');
                        setNotifMessage(errorData.message || 'Gagal membuat data registrasi!');
                        setShowNotif(true);
                        setLoadingSave(false);
                        return;
                    }

                    fetchData();
                } catch (error) {
                    setNotifType('danger');
                    setNotifMessage(error.message || 'Terjadi kesalahan koneksi!');
                    setShowNotif(true);
                } finally {
                    setShowModal(false);
                    setLoadingSave(false);
                    setShowNotif(true);
                }
        }

        const handleCancelConfirm = async (updatedData,data) => {
            if (!updatedData || !data) {
                console.error("Missing data to update.");
                return;
            }
            setLoadingSave(true);
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(`${API_BASE_URL}/auth/registration/${data.id}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify({
                        no_medical_record: data.no_medical_record,
                        status: 'Cancel' 
                    })
                });

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    setNotifType('danger');
                    setNotifMessage(errorData.message || 'Gagal update status registrasi!');
                    setShowNotif(true);
                    setLoadingSave(false);
                    return;
                }


                fetchData();
            } catch (error) {
                alert('Terjadi kesalahan koneksi!');
                setShowCancelModal(false);
                setLoadingSave(false);
            } finally {
                setShowCancelModal(false);
                setLoadingSave(false);
            }
        }

        const handleCancelModal = (item) => {
            setSelectedUser(item);
            setShowCancelModal(true);
        }

        const getBadgeClass = (status) => {
            switch (status) {
                case 'Cancel':
                case 'Canceled':
                    return 'badge badge-light-danger';
                case 'Refund':
                    return 'badge badge-light-warning';
                case 'Receipt':
                    return 'badge badge-light-success';
                case 'Being Handled':
                    return 'badge badge-light-info';
                default:
                    return 'badge badge-light-secondary';
            }
        };
        
        return (
            <>
                <div className="table-responsive">
                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                        <thead>
                            <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                <th className="min-w-100px">ACTIONS</th>
                                <th className="min-w-100px">PATIENT</th>
                                <th className="min-w-75px">NO REGIST</th>
                                <th className="min-w-75px">NO MR</th>
                                <th className="min-w-100px">PHONE NUMBER</th>
                                <th className="min-w-100px">DOCTOR</th>
                                <th className="min-w-75px">ROOM</th>
                                <th className="min-w-75px">DATE REGIST</th>
                                <th className="min-w-100px">MEMBER TYPE</th>
                                <th className="min-w-100px">CREATED BY</th>
                                <th className="min-w-100px">STATUS</th>
                            </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                            {filteredData.map((item, index) => (
                                <tr key={index}>
                                    <td ref={(el) => (dropdownRef.current[index] = el)}>
                                        <SButton
                                         className={"btn btn-light-secondary"}
                                         children={actions()}
                                         action={() => toggleAction(index)}
                                        />

                                        {activeIndex === index && (
                                            <div  
                                                id={`dropdown-${index}`}
                                                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-200px py-4"
                                                style={{
                                                    display: "block",
                                                    position: "absolute",
                                                    zIndex: 1000,
                                                }}
                                            >
                                               <div className="menu-item px-3">
                                                    <SButton
                                                        className={'menu-link px-3 w-100'}
                                                        variant={'transparent'}
                                                        size={'sm'}
                                                        action={() => navigate('/package-history',{
                                                            state: {
                                                                ...item,
                                                                from: [
                                                                    {label: 'Registration', path: '/registration'},
                                                                ]
                                                            }
                                                        })}    
                                                    >
                                                        Package History
                                                    </SButton>
                                                </div>
                                                {item.status !== "Cancel" && item.status !== "Refund" && (
                                                    <>
                                                        {item.status !== "Being Handled" && (
                                                            <div className="menu-item px-3">
                                                                <a href="/" className="menu-link px-3">
                                                                    Refund
                                                                </a>
                                                            </div>
                                                        )}
                                                        <div className="menu-item px-3">
                                                            <SButton
                                                                className={'menu-link px-3 w-100'}
                                                                variant={'transparent'}
                                                                size={'sm'}
                                                                action={() => navigate('/pos',{
                                                                    state: {
                                                                        ...item,
                                                                        from: [
                                                                            {label: 'Registration', path: '/registration'},
                                                                        ]
                                                                    }
                                                                })}    
                                                            >
                                                                Payment
                                                            </SButton>
                                                        </div>
                                                        <div className="menu-item px-3">
                                                            <SButton
                                                                className={'menu-link px-3 w-100'}
                                                                variant={'transparent'}
                                                                size={'sm'}
                                                                action={() => navigate('/doctor-review',{
                                                                    state: {
                                                                        ...item,
                                                                        from: [
                                                                            {label: 'Registration', path: '/registration'},
                                                                        ]
                                                                    }
                                                                })}    
                                                            >
                                                                Doctor Review
                                                            </SButton>
                                                        </div>
                                                        <div className="menu-item px-3">
                                                            <SButton
                                                                className={'menu-link px-3 w-100'}
                                                                variant={'transparent'}
                                                                size={'sm'}
                                                                action={() => {
                                                                    setActiveIndex(null); 
                                                                    handleEditModal(item)
                                                                }}
                                                            >
                                                                Edit
                                                            </SButton>
                                                        </div>
                                                        <div className="menu-item px-3">
                                                            <SButton
                                                                className={'menu-link px-3 w-100'}
                                                                variant={'transparent'}
                                                                size={'sm'}
                                                                action={() => handleCancelModal(item)}
                                                            >
                                                                Cancel
                                                            </SButton>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                    <td>{item.full_name}</td>
                                    <td>{item.no_regist}</td>
                                    <td className='text-end'>{item.no_medical_record}</td>
                                    <td className='text-end'>{item.phone_number}</td>
                                    <td>
                                        {
                                            (therapisOpt.find(opt => String(opt.value) === String(item.doctor))?.label)
                                            || '-'
                                        }
                                    </td>
                                    <td>
                                        {
                                            (optRoom.find(opt => String(opt.value) === String(item.room_id))?.label)
                                            || '-'
                                        }
                                    </td>
                                    <td>{formatDate(item.created_at)}</td>
                                    <td>-</td>
                                    <td>{item.created_by}</td>
                                    <td> 
                                        <div className={getBadgeClass(item.status)}>
                                            {item.status}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <PaginationCustom
                        data={arr || []}
                        page={10}
                        current={1}
                        onPaginate={handlePagination}
                    />
                    { showNotif && (
                        <ShowAlert 
                            title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                            message={notifMessage}
                            pic={notifType === 'success' ? Ceklis : undefined}
                            show={showNotif} 
                            setShow={setShowNotif}
                            onClose={handleCloseConfirm}
                            swal={notifType === 'success' ? 'swal2-success' : 'swal2-danger'}
                        />
                    )}
                    {showModal && currentData && (
                        <ModalForm
                            show={showModal}
                            handleClose={handleCloseModal}
                            data={currentData}
                            formDatas={fields}
                            title={'Edit Registration'}
                            handleSave={handleSaveModal}
                        />
                    )}
                    {showCancelModal && (
                        <ConfirmModal 
                            title={'No, Return'}
                            title2={'Yes, Cancel It!'}
                            message={`Are you sure, ${selectedUser?.full_name} will cancel her Registration?`}
                            show={showCancelModal}
                            setShow={setShowCancelModal}
                            pic={Man}
                            handleSave={handleCancelConfirm}
                            selected={selectedUser}
                        />
                    )}
                </div>
            </>
        )
    }

    return (
        <>
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                <Breadcrumb title={'Home'} header={'Registration'}/>
                <div className='app-container container-xxl d-flex'>
                    <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                        <div className='d-flex flex-column flex-column-fluid'>
                            <div className='app-content'>
                                {isLoading ? (
                                    <CardBasic
                                        className={'card-flush'}
                                        className3={'align-items-center py-5 gap-2 gap-md-5'}
                                        header={CardTitle()}
                                        className2={'pt-0'}
                                    >
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                                            <div className="spinner-border text-primary" role="status"></div>
                                        </div>
                                    </CardBasic> 
                                ) : (
                                    <CardBasic
                                        className={'card-flush'}
                                        className3={'align-items-center py-5 gap-2 gap-md-5'}
                                        header={CardTitle()}
                                        className2={'pt-0'}
                                        children={
                                        <ListBody 
                                            arr={newData} 
                                            fetchData={fetchData}
                                            therapisOpt={therapisOpt}
                                            optRoom={optRoom}
                                        />
                                        }
                                    /> 
                                ) }
                            </div>
                        </div>
                        <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
                            <div className='text-dark order-2 order-md-1'>
                                <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                            </div>
                            <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                                <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                                <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {loadingSave && (
                <div
                    style={{
                    position: 'fixed',
                    zIndex: 2000,
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.6)',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}></div>
                </div>
            )}
        </>
    )
}

export default Registration
